import { useMyProfile } from '../session/useMyProfile.ts'
import { usePlanDownloads, usePlanFiles, useSeriesFiles } from './usePlanFiles.ts'
import { useSeries, useTeams } from './useServices.ts'
import { usePlanSermon } from './useSuggestions.ts'
import { usePlanIdeasPrefetch } from './useSermonIdeas.ts'

/**
 * What a plan's sections show beyond the plan itself (its teams, files and
 * series), asked for as the plan opens. A phone shows one section at a time,
 * so without this a pill would open a section that only starts loading on the
 * tap; with it, the section is already there.
 */
export function usePlanSections(planId: string, seriesId: string | null) {
  useTeams()
  useMyProfile()
  usePlanFiles(planId)
  usePlanDownloads(planId)
  usePlanSermon(planId)
  // The Series section's sermon hub: its ideas and song suggestions (Editors).
  usePlanIdeasPrefetch(planId)
  useSeries(seriesId)
  useSeriesFiles(seriesId ?? '')
}
